export enum StatType {
    Mana = 0,
    Health = 1,
    Endurance = 2,
    Agility = 3,
    Strength = 4,
    Intellect = 5,
    Spirit = 6,
    Stamina = 7,
    Energy = 8,
    Rage = 9,
    Focus = 10,
    WeaponSkillRating = 11,
    DefenseSkillRating = 12,
    DodgeRating = 13,
    ParryRating = 14,
    BlockRating = 15,
    HitMeleeRating = 16,
    HitRangedRating = 17,
    HitSpellRating = 18,
    CritMeleeRating = 19,
    CritRangedRating = 20,
    CritSpellRating = 21,
    Corruption = 22,
    CorruptionResistance = 23,
    ModifiedCraftingStat1 = 24,
    ModifiedCraftingStat2 = 25,
    CritTakenRangedRating = 26,
    CritTakenSpellRating = 27,
    HasteMeleeRating = 28,
    HasteRangedRating = 29,
    HasteSpellRating = 30,
    HitRating = 31,
    CritRating = 32,
    HitTakenRating = 33,
    CritTakenRating = 34,
    ResilienceRating = 35,
    HasteRating = 36,
    ExpertiseRating = 37,
    AttackPower = 38,
    RangedAttackPower = 39,
    VersatilityRating = 40,
    SpellHealingDone = 41,
    SpellDamageDone = 42,
    ManaRegeneration = 43,
    ArmorPenetrationRating = 44,
    SpellPower = 45,
    HealthRegen = 46,
    SpellPenetration = 47,
    BlockValue = 48,
    MasteryRating = 49,
    ExtraArmor = 50,
    FireResistance = 51,
    FrostResistance = 52,
    HolyResistance = 53,
    ShadowResistance = 54,
    NatureResistance = 55,
    ArcaneResistance = 56,
    PvpPower = 57,
    AmplifyRating = 58,
    MultistrikeRating = 59,
    ReadinessRating = 60,
    SpeedRating = 61,
    LifestealRating = 62,
    AvoidanceRating = 63,
    SturdinessRating = 64,
    AgilityStrengthIntellect = 71,
    AgilityStrength = 72,
    AgilityIntellect = 73,
    StrengthIntellect = 74,

    Armor = 1000,
    Power = 1001,
    PowerType = 1002,
    VersatilityDamageDone = 1003,
    VersatilityDamageTaken = 1004,
    VersatilityHealingDone = 1005,
}
